<!--
  This is a temporary component to display the affected system items in a test page.
-->
<template>
  <div v-if="items && items.length > 0" class="right-rail">
    <div class="related-resources">
      <h3 class="related-resources__header">Related Resources</h3>
      <a href="/cis-benchmarks/">
        <img
          src="../../../assets/images/CIS_Benchmarks_RGB_TM.png"
          alt="CIS Benchmark"
          class="related-resources__logo"
        />
      </a>
    </div>

    <div v-for="item in items" :key="item.name">
      <a :href="`/benchmark/${item.url}`" class="c-cta--secondary">
        <span>{{ item.displayName.replace('_', ' ').replace('(msisac)', '') }}</span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CIS-Resource-Advisory-RelatedBenchmark',
  props: {
    items: {
      type: Array
    }
  }
};
</script>
